module.exports = __webpack_public_path__ + "static/media/footer-logo.36dc54f0.svg";